import { Component } from '@angular/core';
import { App, NavController } from 'ionic-angular';
// pages
import { AccountForgotPage } from '../account-forgot/account-forgot';
import { AccountSignupPage } from '../account-signup/account-signup';

/**
 * Login Page
 * 
 * @export
 * @class AccountLoginPage
 */
@Component({
    selector: 'account-login',
    templateUrl: 'account-login.html'
})
export class AccountLoginPage {

    constructor(public app: App, public nav: NavController) {

    }
    ionViewDidEnter() {
        this.app.setTitle('Login');
    }
    onSignup() {
        this.nav.push(AccountSignupPage);
    }

    onForgot() {
        this.nav.push(AccountForgotPage);
    }

}


// WEBPACK FOOTER //
// ./src/pages/account-login/account-login.ts